import React from 'react';
import { ResourceCenter } from 'cccisd-laravel-resources';

const OnlineTraining = props => {
    return (
        <div className="container">
            <ResourceCenter {...props} />
        </div>
    );
};

export default OnlineTraining;
